import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles( theme => ({
    backBar:{
        marginTop: '2rem',
        marginLeft: '2rem'
    },
    formBox: {
        border: "2px solid black",
        borderRadius: 10,
        marginBottom: theme.spacing(3),
        marginTop: theme.spacing(2),
        padding: theme.spacing(3),
        width: "100%"
    },
    formDataCell: {
        minHeight: theme.spacing(4)
    },
    formLabel: {
        marginBottom: theme.spacing(2),
        fontWeight: "bold"
    },
    radioContainer: {
        position: "relative",
        top: -10,
    },
    standOutText: {
        fontSize: "1.25rem",
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontWeight: 500,
        lineHeight: 1.6,
        letterSpacing: "0.0075em"
    }
}));

export default useStyles;